import { Injectable } from '@angular/core';
import { SortModel, SortResult } from './sort.model';

@Injectable()
export class SortService {
    constructor() { }
    public toggleTableColumnSort(sortField: SortModel, sortDirectionAsc: boolean, sort: SortModel): SortResult {
        let sortResult = new SortResult(sortField, sort, sortDirectionAsc);
        if (sort === sortField) {
            if (sort.selectedOrder === SortModel.ascIcon) {
                sortResult.selectedSortModel.selectedOrder = SortModel.descIcon;
                sortResult.sortDiresctionAsc = false;
            }
            else {
                if (sort.selectedOrder === SortModel.descIcon) {
                    sortResult.selectedSortModel.selectedOrder = SortModel.ascIcon;
                    sortResult.sortDiresctionAsc = true;
                }
            }
        }
        else {
            sortResult.existingSortModel.selectedOrder = SortModel.disabledIcon;//disable the previous
            sortResult.selectedSortModel.selectedOrder = SortModel.ascIcon;
            sortResult.existingSortModel = sortResult.selectedSortModel;
            sortResult.sortDiresctionAsc = true;
        }
        return sortResult;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/sort.service.ts